<h4>
  Confira sua inscrição no Seguro Icatu
</h4>


<h5 class="mt-4">
  Dados Cadastrais:
</h5>

<ol class="mt-1 ml-0 cadastro">
  <li>
    <strong>Nome:</strong> {{dados?.cad?.NOME}}
    <a class="ml-2" target="_blank" routerLink="/logado/cadastro" fragment="dados-pessoais">[editar]</a>
  </li>
  <li>
    <strong>Nome Social *:</strong> {{dados?.cad?.NOME_SOCIAL}}
    <a class="ml-2" target="_blank" routerLink="/logado/cadastro" fragment="dados-pessoais">[editar]</a>
    <small class="form-text text-muted">* Nome que respeita a identidade de gênero da pessoa e pelo qual ela é identificada, diferindo do nome de registro. Preenchimento não obrigatório.</small>
    <br />
  </li>
  <li>
    <strong>Data Nasc:</strong> {{dados?.cad?.DTA_NASC| date:"dd/MM/yyyy"}}
  </li>
  <li class="mt-1">
    <strong>Ocupação:</strong> {{dados?.simulacao?.DCR_OCUPACAO}}
    <a class="ml-2" target="_blank" href="" (click)="abrirPersonalizar(); false;">[editar]</a>
  </li>
  <li class="mt-1">
    <strong>Renda Mensal Atual:</strong> {{dados?.simulacao?.VLR_RENDA| currency:'R$'}}
    <a class="ml-2" target="_blank" href="" (click)="abrirPersonalizar(); false;">[editar]</a>
  </li>
  <li class="mt-1">
    <strong>Aposentado:</strong> {{dados?.simulacao?.DEC_APOSENTADO == 'S' ? 'Sim' : 'Não' }}
  </li>
  <li class="mt-1">
    <strong>Cobertura:</strong>

    {{dados?.simulacao?.DEC_MORTE=='S' ? 'Morte': ''}}

    {{dados?.simulacao?.DEC_MORTE=='S' && dados?.simulacao?.DEC_INVALIDEZ=='S' ? ' + ' : ''}}

    {{dados?.simulacao?.DEC_INVALIDEZ=='S' ? 'Invalidez': ''}}
  </li>
  @if (dados?.simulacao?.DEC_MORTE=='S') {
    <li class="mt-1">
      <strong>Valor da Cobertura por Morte:</strong> {{dados?.simulacao?.VLR_COBERTURA_MORTE| currency:'R$'}}
    </li>
  }
  @if (dados?.simulacao?.DEC_INVALIDEZ=='S') {
    <li class="mt-1">
      <strong>Valor da Cobertura por Invalidez:</strong> {{dados?.simulacao?.VLR_COBERTURA_INVALIDEZ| currency:'R$'}}
    </li>
  }
  <li class="mt-1">
    <strong>Endereço:</strong> {{dados?.cad?.DCR_END}}, {{dados?.cad?.DCR_CIDADE}}/{{dados?.cad?.COD_UF}}
    <a class="ml-2" target="_blank" routerLink="/logado/cadastro" fragment="endereco">[editar]</a>
  </li>
  <li class="mt-1">
    <strong>PPE (Pessoa Politicamente Exposta):</strong> {{dados?.cad?.DCR_USPERSON}}
    <a class="ml-2" target="_blank" routerLink="/logado/cadastro" fragment="termos">[editar]</a>
  </li>
  <li class="mt-1">
    <strong>Beneficiários:</strong>
    <a class="ml-2" target="_blank" routerLink="/logado/cadastro" fragment="beneficiarios">[editar]</a>

    <div class="ml-3">
      <ul class="list-unstyled">
        @for (item of dados?.deps; track item) {
          <li>
            {{item.NOME_BENEF}} CPF: {{item.DCR_CPF_BENEF}}
          </li>
        }
      </ul>
    </div>
  </li>
  <li class="mt-1">
    <strong>Forma de Pagamento:</strong> {{dados?.cad?.DCR_FORMA_PGTO}}
    <a class="ml-2" target="_blank" routerLink="/logado/financeiro/formas-pagamentos">[editar]</a>
  </li>
</ol>


<h5 class="mt-4">
  Prêmio: {{(dados?.simulacao?.VLR_PREMIO_MORTE + dados?.simulacao?.VLR_PREMIO_INVALIDEZ)| currency:'R$'}}/mês
</h5>

<h5 class="mt-4">
  Declaração de Saúde:
</h5>

<div class="declaracaoSaude border bg-light p-3 m-t3">
  <ul class="list-unstyled">
    <li>
      1- É portador (ou já foi portador) de hipertensão arterial, diabetes mellitus, doença renal, neurológica, do estômago, intestino, fígado, pâncreas, reumática, câncer (incluindo linfoma e leucemia), infectocontagiosa ou sexualmente transmissível (incluindo HIV e hepatite) ou alguma outra doença? Em caso afirmativo informe qual(is)?
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_01)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_01=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_01}}
        </p>
      }
    </li>
    <li class="mt-2">
      2- É portador de alguma deficiência de órgãos, membros ou sentidos (audição, visão, etc.). Em caso afirmativo informe detalhes.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_02)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_02=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_02}}
        </p>
      }
    </li>
    <li class="mt-2">
      3- Já sofreu alguma lesão traumática com fratura, luxação, entorse ou lesão ligamentar? Em caso afirmativo informe quando aconteceu, se foi necessário o afastamento da atividade laborativa, por quanto tempo e sequelas.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_03)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_03=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_02}}
        </p>
      }
    </li>
    <li class="mt-2">
      4- Já foi submetido(a) a tratamentos quimioterápico, radioterápico, diálise, cirurgia, biópsia, punção ou internação hospitalar? Em caso afirmativo especifique qual(is), quando e o(s) motivo(s).
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_04)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_04=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_04}}
        </p>
      }
    </li>
    <li class="mt-2">
      5- Já foi submetido(a) a exames como cateterismo, ecocardiograma, tomografia, ressonância magnética, endoscopia, etc.? Em caso afirmativo especifique qual(is), quando, o(s) motivo(s) e resultado(s).
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_05)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_05=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_05}}
        </p>
      }
    </li>
    <li class="mt-2">
      6- Faz uso regular de algum medicamento? Em caso afirmativo informar qual(is) medicamento(s) e a dose.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_06)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_06=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_06}}
        </p>
      }
    </li>
    <li class="mt-2">
      7- Fuma ou fumou nos últimos três anos? Em caso afirmativo informar a frequência, a quantidade e o tipo (cigarro, charuto, etc.).
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_07)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_07=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_07}}
        </p>
      }
    </li>
    <li class="mt-2">
      8- Consome bebidas alcoólicas mais do que 3 (três) vezes por semana? Em caso afirmativo informar o tipo de bebida, a quantidade e a frequência do consumo.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_08)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_08=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_08}}
        </p>
      }
    </li>
    <li class="mt-2">
      9- Pratica algum tipo de modalidade esportiva, em caráter profissional ou amador (ex.: mergulho, voo livre, paraquedismo) ou atividade a bordo de aeronaves? Em caso afirmativo especifique a atividade e a última vez que praticou.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_09)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_09=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_09}}
        </p>
      }
    </li>
    <li class="mt-2">
      10- Algum membro da família (pais ou irmãos) sofre ou sofreu de alguma doença antes dos 65 anos de idade? Se sim, informe a doença, a idade do diagnóstico da doença, o parentesco e a condição.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_10)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_10=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_10}}
        </p>
      }
    </li>
    <li class="mt-2">
      11- Possui atualmente ou está em fase de contratação de outro seguro de vida ou de acidentes pessoais? Em caso afirmativo informe a seguradora, coberturas e capital contratado.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_11)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_11=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_11}}
        </p>
      }
    </li>
    <li class="mt-2">
      12- Alguma seguradora já recusou ou agravou algum seguro de vida ou de acidentes pessoais em seu nome? Em caso afirmativo informe se foi recusa ou agravo e o motivo.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_12)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_12=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_12}}
        </p>
      }
    </li>
    <li class="mt-2">
      13- Fez ou faz uso de algum tipo de droga, como alucinógenos, narcóticos, cocaína, maconha, etc.? Em caso afirmativo informe tipo, quantidade, frequência e última vez que utilizou.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_13)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_13=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_13}}
        </p>
      }
    </li>
    <li class="mt-2">
      14- Sofreu alguma alteração de peso (perda ou ganho) de mais de 10kgs nos últimos 6 meses? Em caso afirmativo informe se houve perda ou ganho, a alteração em kg e especifique o motivo.
      <p>
        <strong class="text-black-50">Resposta:</strong> {{SimNao(decSaude?.DCR_PERGUNTA_14)}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_14=='S') {
        <p>
          <strong class="text-black-50">Justificativa:</strong> {{decSaude?.DCR_JUSTIFICATIVA_14}}
        </p>
      }
    </li>
    <li class="mt-2">
      15- Altura:
      <p>
        <strong class="text-black-50">Resposta:</strong> {{decSaude?.VLR_PERGUNTA_15}}
      </p>
    </li>
    <li class="mt-2">
      16- Peso :
      <p>
        <strong class="text-black-50">Resposta:</strong> {{decSaude?.VLR_PERGUNTA_16}}
      </p>
    </li>
    <li class="mt-2">
      17- Motivo Aposentadoria:
      <p>
        <strong class="text-black-50">Resposta:</strong> {{decSaude?.DCR_PERGUNTA_17}}
      </p>
      @if (decSaude?.DCR_PERGUNTA_17=='Invalidez') {
        <p>
          <strong class="text-black-50">Causa da aposentadoria por invalidez:</strong> {{decSaude?.DCR_JUSTIFICATIVA_17}}
        </p>
      }
    </li>
  </ul>
</div>
<a class="d-block" style="font-size: 12px;" href="" (click)="abrirDeclaracaoSaude(); false;">Editar declaração de saúde</a>

<h5 class="mt-4">Termos:</h5>

<div class="termo border bg-light p-3 m-t3">
  <app-termo-seguro></app-termo-seguro>
</div>

<div class="form-group form-check">
  <input type="checkbox" class="form-check-input" id="ckAceite2" [(ngModel)]="ckTermo" />
  <label class="form-check-label" for="ckAceite2">Eu Aceito</label>
</div>



<div class="mt-3 row justify-content-between">
  <div class="col-4 text-left p-0">
    <button type="button" class="btn btn-primary" (click)="voltar()">
      <i class="fas fa-chevron-left"></i>
      Voltar
    </button>
  </div>
  <div class="col-8 text-right p-0">
    <div class="input-group">
      <input type="password" class="form-control" placeholder="Assinatura Eletrônica" style="box-shadow: none;" [(ngModel)]="assinatura" [disabled]="!ckTermo || loading">
      <div class="input-group-append">
        <button class="btn btn-success" type="button" (click)="finalizar()" [disabled]="loading || !ckTermo || assinatura==null || assinatura==''">
          Salvar
          @if (loading) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>
  </div>
</div>